import React from 'react'
import { useAuthentication } from 'hooks/useAuthentication'
import { Redirect, Route } from 'react-router-dom'

// @constants
import { RUTAS } from 'constants/constants'

export function PrivateRoute({ children, ...rest }) {
  const { isAuth } = useAuthentication()
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuth ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: RUTAS.LOGIN,
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}
